import { Component, DoCheck, OnInit, Renderer2 } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Consultant } from './models/consultant.model';
import { fromConsultant } from './reducers/consultant.reducer';
import { AuthenticationService } from './services/authentication.service';
import { UtilsService } from './services/utils.service';
import jwtDecode from 'jwt-decode';
import { fromTest } from './reducers/test.reducer';
import { fromCandidate } from './reducers/candidate.reducer';

@Component({
  selector: 'ct-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, DoCheck {

  module: string;
  consultant$: Observable<Consultant>;
  clientId;

  constructor(
    public title: Title,
    public meta: Meta,
    private router: Router,
    private renderer: Renderer2,
    private translateService: TranslateService,
    private store: Store,
    public utilsService: UtilsService,
    private authenticationService: AuthenticationService
  ) { }

  ngDoCheck() {

    // Hacer seguimiento de la ruta actual para usar los estilos especificos
    if (this.router.url.includes('/error')) {
      this.module = 'error';
    } else {
      this.module = this.router.url.split('/')[1];
    }

    this.renderer.setAttribute(document.body, 'id', this.module + 'Module');

    if (this.module === 'report') {
      this.meta.removeTag('name="viewport"');
      this.meta.addTag({ name: 'viewport', content: 'width=device-width, initial-scale=0.1' });
    }

  }

  ngOnInit() {
    this.title.setTitle('Relevate Talent Assessment');
    this.meta.updateTag({ description: 'Bienvenido a Relevate Talent Assessment' });

    // comprobamos si el token de consultor esta caducado
    if (window.location.href.includes('/consultant')) {
      this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
      this.checkExpiration();
      // Revisamos si ya esta logado para saber el idioma que le ponemos por defecto
      this.consultant$.subscribe(consultant => {
        if (consultant?.client) {
          // Seteamos el idioma del cliente
          this.translateService.use(consultant.client.defaultLanguage);
          this.translateService.setDefaultLang(consultant.client.defaultLanguage);
          document.documentElement.lang = consultant.client.defaultLanguage.split('-')[0];
        } else {
          this.translateService.use('es-ES');
          this.translateService.setDefaultLang('es-ES');
          document.documentElement.lang = 'es';
        }
      });
    } else if (window.location.href.includes('candidate/test')) {
      this.store.pipe(select(fromTest.selectTestState)).subscribe(test => {
        this.clientId = test.clientId;
      });
    }
    else if (window.location.href.includes('/candidate')) {
      this.store.pipe(select(fromCandidate.selectCandidateState)).subscribe(candidate => {
        this.clientId = candidate.clientId;
      });
    }
  }

  checkExpiration() {
    this.consultant$.subscribe(consultant => {
      if (consultant?.token) {
        const token = jwtDecode(consultant.token)
        if (Date.now() > token['exp'] * 1000) {
          this.authenticationService.logOut('consultant');
        }
      }
    });
  }

}
